var map = {
	"./Base": 715,
	"./Base/": 715,
	"./Base/index": 715,
	"./Base/index.js": 715,
	"./Base/style": 174,
	"./Base/style.js": 174,
	"./Clutch": 422,
	"./Clutch/": 422,
	"./Clutch/index": 422,
	"./Clutch/index.js": 422,
	"./Clutch/renderComponent": 1617,
	"./Clutch/renderComponent.js": 1617,
	"./Clutch/style": 1278,
	"./Clutch/style.js": 1278,
	"./NewUi": 999,
	"./NewUi/": 999,
	"./NewUi/index": 999,
	"./NewUi/index.js": 999,
	"./NewUi/style": 1279,
	"./NewUi/style.js": 1279,
	"./OldUi": 1000,
	"./OldUi/": 1000,
	"./OldUi/index": 1000,
	"./OldUi/index.js": 1000,
	"./OldUi/renderComponent": 1618,
	"./OldUi/renderComponent.js": 1618,
	"./OldUi/style": 1280,
	"./OldUi/style.js": 1280,
	"./SpireonNew": 1001,
	"./SpireonNew/": 1001,
	"./SpireonNew/index": 1001,
	"./SpireonNew/index.js": 1001,
	"./SpireonNew/renderComponent": 1619,
	"./SpireonNew/renderComponent.js": 1619,
	"./SpireonNew/style": 1281,
	"./SpireonNew/style.js": 1281,
	"./SpireonOld": 1002,
	"./SpireonOld/": 1002,
	"./SpireonOld/index": 1002,
	"./SpireonOld/index.js": 1002,
	"./SpireonOld/renderComponent": 1620,
	"./SpireonOld/renderComponent.js": 1620,
	"./SpireonOld/style": 1282,
	"./SpireonOld/style.js": 1282
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82;